import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  input: {
    height: 150,
    marginTop: -10,
    textAlignVertical: 'top',
    lineHeight: 22,
    maxHeight: 200,
  },
  inputContainer: {
    borderWidth: 1,
    width: '100%',
    borderRadius: 15,
    marginTop: 10,
  },
  actionButton: {
    borderRadius: 50,
    marginTop: 10,
  },
  bottomsheet: {width: '100%'},
  closeButton: {
    alignSelf: 'flex-end',
    marginRight: 5,
    marginBottom: 5,
    marginTop: 5,
  },
  textCount: {alignSelf: 'flex-end', marginTop: 10},
});
